export default __webpack_public_path__ + "static/media/Shemite Wayfarer Wristbands.3a7d1cb6.jpg";